import * as cx from 'classnames';
import { FORMS_DEFAULT_REQUIRED_FIELD_ERROR } from 'mk/autogenerated/translations/Textarea.fa0f011978bedf4bb8977faaca663b15'
import FieldWrapper from 'mk/forms/FieldWrapper';
import * as React from 'react';

interface OwnProps {
    className?: string;
    errors?: string[];
    rows?: number;
    maxLength?: number;
    placeholder?: string;
    initial?: string;
    name: string;
    label?: string;
    autofocus?: boolean;
    initialCursorAtBeginning?: boolean;
    required?: boolean;

    onChange?(value: string);
}

interface State {
    value: string;
}

export class Textarea extends React.Component<OwnProps, State> {

    public static defaultProps = {
        initial: '',
    };

    private textarea: HTMLTextAreaElement;

    public static isFormField() {
        return true;
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
            value: props.initial,
        };
    }

    public validate() {
        if (this.props.required && !this.state.value) {
            return [null, [FORMS_DEFAULT_REQUIRED_FIELD_ERROR]];
        }

        return [this.state.value, null];
    }

    public clear() {
        if (!this.hasValue()) {
            return;
        }

        this.setState({
            value: this.props.initial,
        });

        // Notify parent about change
        if (this.props.onChange) {
            this.props.onChange(this.props.initial);
        }
    }

    public hasValue() {
        return this.state.value;
    }

    public getValue() {
        return this.state.value;
    }

    public setValue(value) {
        this.setState({ value });
    }

    public componentDidMount() {
        if (this.props.initial) {
            if (this.props.autofocus) {
                this.moveCursorToEnd();
            }
            if (this.props.initialCursorAtBeginning) {
                this.moveCursorToPosition(0);
            }
        }
    }

    public componentWillReceiveProps(nextProps) {
        if (this.props.initial !== nextProps.initial) {
            this.setState({value: nextProps.initial});
        }
    }

    public render() {
        const {name, label} = this.props;

        return (
            <FieldWrapper
                className={cx('textarea', this.props.className)}
                label={label}
                errors={this.props.errors}
                name={name}
                htmlFor={name}
            >
                <textarea
                    id={name}
                    value={this.state.value}
                    onChange={this.onChange}
                    ref={(r) => this.textarea = r}
                    className="g-form-textarea"
                    rows={this.props.rows}
                    maxLength={this.props.maxLength}
                    placeholder={this.props.placeholder}
                />
            </FieldWrapper>
        );
    }

    public setFocus(callBack) {
        // http://note.io/1Jtcl53
        setTimeout(() => {
            this.textarea.focus();
            if (callBack) {
                callBack();
            }
        }, 0);
    }

    public moveCursorToEnd() {
        this.moveCursorToPosition(this.state.value.length);
    }

    /**
     * move cursor to specified position
     * @arg {number} position
     */
    public moveCursorToPosition(position) {
        const el = this.textarea;
        el.selectionStart = el.selectionEnd = position;
    }

    /**
     * insert text into the text area in the position specified by the cursor.
     * This also handles case when range of text is selected, in which case
     * selected text will be replaced.
     * @arg {string} text - text to be inserted
     * @return {number} - position right after the inserted text
     */
    public insert(text) {
        const textareaNode = this.textarea;
        if (textareaNode.selectionStart !== undefined
            && textareaNode.selectionEnd !== undefined
        ) {
            const start = textareaNode.selectionStart;
            const end = textareaNode.selectionEnd;
            const head = this.state.value.substring(0, start);
            const tail = this.state.value.substring(end);

            const value = head + text + tail;
            this.setState({value});
            return (head + text).length;
        } else {
            const value = this.state.value + text;
            this.setState({value});
            return value.length;
        }
    }

    private onChange = (event) => {
        this.setState({value: event.target.value});
        // Notify parent about change
        if (this.props.onChange) {
            this.props.onChange(event.target.value);
        }
    };

}
